import { gql } from '@apollo/client/core';

export const COLLECTION_METADATA_FIELDS = gql`
  fragment CollectionMetadataFields on CollectionMetadata {
    currentPage
    limitValue
    totalCount
    totalPages
  }
`;

export type CollectionArguments = {
  page?: number;
  limit?: number;
};
